import { Box, Typography, alpha } from "@mui/material";

interface PickupEntryInfoRowProps {
  label: string;
  value: string;
  labelFontWeight?: 400 | 700;
  labelFontSize?: string;
  valueFontSize?: string;
}

export const PickupEntryInfoRow = ({
  label,
  value,
  labelFontWeight = 700,
  labelFontSize = "12px",
  valueFontSize = "14px",
}: PickupEntryInfoRowProps) => (
  <Box component="section" aria-label={label}>
    <Typography
      sx={{
        fontSize: labelFontSize,
        fontWeight: labelFontWeight,
        color: "text.primary",
        mb: 0.5,
        lineHeight: labelFontSize === "20px" ? "160%" : "normal",
        letterSpacing: labelFontSize === "20px" ? "0.15px" : "normal",
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: valueFontSize,
        fontWeight: 400,
        color: (theme) => alpha(theme.palette.text.primary, 0.87),
        lineHeight: "143%",
        letterSpacing: "0.17px",
      }}
    >
      {value}
    </Typography>
  </Box>
);
